import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { isEmpty, sortBy, orderBy } from 'lodash';

import { connect, useDispatch } from 'react-redux';
import moment from 'moment';

import TextField from '@material-ui/core/TextField';
import AutoComplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';

import BobPage from '../../../components/BobPage';
import ExecutiveSummaryScoreGuage from './ExecutiveSummaryScoreGuage';
import ExecutiveSummaryEquipmentsTable from './ExecutiveSummaryEquipmentsTable';
import ExecutiveSummarySitesTable from './ExecutiveSummarySitesTable';
import ExecutiveSummaryAgentsTable from './ExecutiveSummaryAgentsTable';
import EntitySelector from '../../../components/EntitySelector';
import BobTimeStampFilter from '../../../components/RuleExceptionsTable/BobTimestampFilter';
import BobLoadingMask from '../../../components/BobLoadingMask';
import * as EnergyActions from '../../../actions/energyActions';
import { TileLayout } from '@progress/kendo-react-layout';
import * as CompanyManagementActions from '../../../actions/companyManagementActions';
import { enqueueSnackbar } from '../../../actions/applicationMessageActions';
import * as bobActions from '../../../actions/bobActions';
import * as companyInfoActions from '../../../actions/companyInfoActions';
import * as executiveSummaryActions from '../../../actions/executiveSummaryActions';
import * as configurationActions from '../../../actions/configurationActions';
import * as basAgentActions from '../../../actions/basAgentActions';
import * as lookupActions from '../../../actions/lookupActions';

import * as classes from './ExecutiveSummary.module.css';
import ExecutiveSummaryFaults from './ExecutiveSummaryFaults';
import TileContainer from './TileContainer';
import ExecutiveSummaryTileModal from '../Modals/ExecutiveSummaryTileModal';
import ExecutiveSummaryFaultsByPriority from './ExecutiveSummaryFaultsByPriority';
import ExecutiveSummaryEnergyHogs from './ExecutiveSummaryEnergyHogs';
import ExecutiveSummarEnergyUse from './ExecutiveSummarEnergyUse';
import ExecutiveSummaryFaultsByRule from './ExecutiveSummaryFaultsByRule';
import { Mixpanel } from '../../../helpers/mixpanel';
import TileSelector from './TileSelector';

const MIXPANEL_EVENT = 'Execute Summary';

const ExecutiveSummary = ({
    activeNavCompany,
    configurations,
    attributes,
    companies,
    currentUser,
    dashboardEndTimeStamp,
    dashboardStartTimeStamp,
    fetchAllConfigurations,
    fetchBasAgents,
    fetchCompanyInfo,
    fetchExecutiveTilesLookup,
    fetchApplicationsTiles,
    fetchFaultByPriority,
    fetchFaultByRule,
    fetchNavClients,
    fetchWorstPerformingEquipment,
    fetchEnergyEquipmentSummary,
    fetchEnergyEquipmentGroupSummary,
    fetchSiteScoreData,
    fetchSiteEnergyData,
    history,
    setActiveNavCompany,
    setNavCompany,
    setSiteScoreData,
    sites,
    userId,
    ...props
}) => {
    const [data, setData] = useState([]);
    const [activeClient, setActiveClient] = useState({});
    const [activeSite, setActiveSite] = useState({});
    const [activeEquipmentSystemType, setActiveEquipmentSystemType] = useState({});
    const [activeCompany, setActiveCompany] = useState({});
    const [companyList, setCompanyList] = useState([]);
    const [zoomSite, setZoomSite] = useState({});

    const [summarySites, setSummarySites] = useState([]);
    const [summaryClients, setSummaryClients] = useState([]);
    const [summaryEquipmentSystemTypes, setSummaryEquipmentSystemTypes] = useState([]);

    const [tileModalOpen, setTileModalOpen] = useState(false);
    const [selectedTitle, setSelectedTitle] = useState('');
    const [faultFilters, setFaultFilters] = useState(['low', 'medium', 'high']);
    const [availableTiles, setAvailableTiles] = useState([]);
    const [selectedTiles, setSelectedTiles] = useState([]);
    const [tiles, setTiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [hasInitialized, setHasInitialized] = useState(false);

    const dispatch = useDispatch();

    useEffect(() => {
        const init = async () => {
            Mixpanel.track(MIXPANEL_EVENT, {
                company:  activeNavCompany.name,
                userName: `${currentUser.firstName} ${currentUser.lastName}`,
                email:    currentUser.email
            });
            setActiveCompany(activeNavCompany);
            
            const promises = [fetchAllConfigurations(userId), fetchExecutiveTilesLookup(),fetchApplicationsTiles(), fetchBasAgents(activeNavCompany.id)];

            await Promise.all(promises.map(p => p.catch(err => err))).then(results => {
                let tiles = results[1];
                let apps = results[2];
                tiles = tiles.filter(tile => tile.value !== 'Service Requests');
                setAvailableTiles(grouptiles(tiles,apps));
                
            });
            setHasInitialized(true);
        };

        if (activeNavCompany.id) init();
    }, [activeNavCompany]);

    const grouptiles = (tiles,apps) =>{
        let tileGrp = new Map();
        for (let tile of tiles) {
            if (!tileGrp.get(tile.companyAVPFacets[0].value)) {
                tileGrp.set(tile.companyAVPFacets[0].value,[tile]);
            }
            else tileGrp.get(tile.companyAVPFacets[0].value).push(tile);
        }
        let gps = [];
        for (let [key, value] of  tileGrp.entries()) {
            let gpName = apps.find(c=>c.id === key).name;
            //const superAdmin = currentUser.isSuperUser || currentUser.email.toLowerCase().includes('@key2act.com');
            if (gpName === 'Energy') {
                // if (superAdmin) {
                //     gps.push({gpId: key, group: gpName,apps: orderBy(value, ['value'], ['asc'])});
                // }
            }
            else gps.push({gpId: key, group: gpName,apps: orderBy(value, ['value'], ['asc'])});
        }
        return gps;
    };

    useEffect(() => {
        const init = async () => {
            const tileConfiguration = configurations.find(item => item.viewKey === 'BOB|ExecutiveSummary');
            let activeTiles = [];
            let userTiles = [];

            if (isEmpty(tileConfiguration) || isEmpty(tileConfiguration.viewData)) {
                activeTiles = ['Average Score', 'Site Score', 'Faults by Site', 'BAS Agent Connectivity', '10 Worst Performing Equipment', 'Faults by Priority', 'Faults by Rule', 'Service Requests','Top 10 Energy Hogs','Energy Use by Equipment Type'];
                setSelectedTiles(activeTiles);
            } else {
                const config = tileConfiguration.viewData.selectedTiles || [];

                config.forEach(item => {
                    activeTiles.push(item);
                });
                setSelectedTiles(activeTiles);
            }

            activeTiles.forEach(tile => {
                if (tile === 'Average Score') {
                    userTiles.push({
                        item: (
                            <TileContainer
                                title="Average Score"
                                selectedTitle={selectedTitle}
                                setSelectedTitle={setSelectedTitle}
                                setTileModalOpen={setTileModalOpen}
                            >
                                <ExecutiveSummaryScoreGuage />
                            </TileContainer>
                        )
                    });
                } else if (tile === 'Site Score') {
                    userTiles.push({
                        item: (
                            <TileContainer
                                title="Site Score"
                                selectedTitle={selectedTitle}
                                setSelectedTitle={setSelectedTitle}
                                setTileModalOpen={setTileModalOpen}
                            >
                                <ExecutiveSummarySitesTable
                                    setZoomSite={setZoomSite}
                                    setActiveClient={setActiveClient}
                                    setActiveSite={setActiveSite}
                                    setSites={setSummarySites}
                                    expanded={false}
                                />
                            </TileContainer>
                        )
                    });
                } else if (tile === 'Faults by Site') {
                    userTiles.push({
                        item: (
                            <TileContainer
                                title="Faults By Site"
                                selectedTitle={selectedTitle}
                                setSelectedTitle={setSelectedTitle}
                                setTileModalOpen={setTileModalOpen}
                            >
                                <ExecutiveSummaryFaults zoomSite={zoomSite} />
                            </TileContainer>
                        )
                    });
                } else if (tile === 'BAS Agent Connectivity') {
                    userTiles.push({
                        item: (
                            <TileContainer
                                title="BAS Agent Connectivity"
                                selectedTitle={selectedTitle}
                                setSelectedTitle={setSelectedTitle}
                                setTileModalOpen={setTileModalOpen}
                            >
                                <ExecutiveSummaryAgentsTable expanded={false} />
                            </TileContainer>
                        )
                    });
                } else if (tile === '10 Worst Performing Equipment' || tile === '10 Worst Performing Systems') {
                    userTiles.push({
                        item: (
                            <TileContainer
                                selectedTitle={selectedTitle}
                                title={activeEquipmentSystemType?.grouping === 'System Type' ? '10 Worst Performing Systems' : '10 Worst Performing Equipment'}
                                setSelectedTitle={setSelectedTitle}
                                setTileModalOpen={setTileModalOpen}
                            >
                                <ExecutiveSummaryEquipmentsTable activeEquipmentSystemType={activeEquipmentSystemType} extendedColumns={false} />
                            </TileContainer>
                        )
                    });
                } else if (tile === 'Faults by Priority') {
                    userTiles.push({
                        item: (
                            <TileContainer
                                title="Faults By Priority"
                                selectedTitle={selectedTitle}
                                setSelectedTitle={setSelectedTitle}
                                setTileModalOpen={setTileModalOpen}
                                faultFilters={faultFilters}
                                setFaultFilters={setFaultFilters}
                            >
                                <ExecutiveSummaryFaultsByPriority
                                    faultFilters={faultFilters}
                                    setFaultFilters={setFaultFilters}
                                />
                            </TileContainer>
                        )
                    });
                } else if (tile === 'Faults by Rule') {
                    userTiles.push({
                        item: (
                            <TileContainer
                                title="Faults By Rule"
                                selectedTitle={selectedTitle}
                                setSelectedTitle={setSelectedTitle}
                                setTileModalOpen={setTileModalOpen}
                            >
                                <ExecutiveSummaryFaultsByRule activeSite={activeSite} />
                            </TileContainer>
                        )
                    });
                } 
                // else if (tile === 'Top 10 Energy Hogs') {
                //     userTiles.push({
                //         item: (
                //             <TileContainer
                //                 title="Top 10 Energy Hogs (Previous Month)"
                //                 selectedTitle={selectedTitle}
                //                 setSelectedTitle={setSelectedTitle}
                //                 setTileModalOpen={setTileModalOpen}
                //             >
                //                 <ExecutiveSummaryEnergyHogs />
                //             </TileContainer>
                //         )
                //     });
                // }
                // else if (tile === 'Energy Use by Equipment Type') {
                //     userTiles.push({
                //         item: (
                //             <TileContainer
                //                 title="Energy Use by Equipment Type"
                //                 selectedTitle={selectedTitle}
                //                 setSelectedTitle={setSelectedTitle}
                //                 setTileModalOpen={setTileModalOpen}
                //             >
                //                 <ExecutiveSummarEnergyUse />
                //             </TileContainer>
                //         )
                //     });

                // }
            });

            setTiles(userTiles);
        };

        if (!isEmpty(configurations) && hasInitialized) {
            init();
        } else if (isEmpty(configurations) && hasInitialized) {
            init();
        }
    }, [configurations, hasInitialized, faultFilters, activeEquipmentSystemType, activeSite]);

    useEffect(() => {
        if (!isEmpty(companies)) {
            let list = [];
            const copy = [...companies];
            copy.forEach(item => list.push(item.company));
            setCompanyList(list);
        }
    }, [companies]);

    useEffect(() => {
        const init = async () => {
            const defaultData = [
                {
                    col:     1,
                    colSpan: 1,
                    rowSpan: 1,
                },
                {
                    col:     2,
                    colSpan: 1,
                    rowSpan: 1,
                },
                {
                    col:     3,
                    colSpan: 1,
                    rowSpan: 1,
                },
                {
                    col:     1,
                    colSpan: 1,
                    rowSpan: 1,
                },
                {
                    col:     2,
                    colSpan: 1,
                    rowSpan: 1,
                },
                {
                    col:     3,
                    colSpan: 1,
                    rowSpan: 1,
                },
                {
                    col:     1,
                    colSpan: 1,
                    rowSpan: 1
                },
                {
                    col:     2,
                    colSpan: 1,
                    rowSpan: 1,
                },
                {
                    col:     3,
                    colSpan: 1,
                    rowSpan: 1,
                }];

            const configuration = JSON.parse(localStorage.getItem(`ExecutiveSummaryConfig-${userId}`));
            if (!isEmpty(configuration)) {
                if (defaultData.length !== configuration.length) {
                    setData(defaultData);
                    localStorage.removeItem(`ExecutiveSummaryConfig-${userId}`);
                } else {
                    setData(configuration);
                }
            } else {
                setData(defaultData);
            }
        };

        if (userId) init();
    }, [userId]);

    useEffect(() => {
        const init = async () => {
            await Promise.all([
                fetchFaultByRule(activeNavCompany.id, null, null, { StartDate: dashboardStartTimeStamp, EndDate: dashboardEndTimeStamp }),
                fetchFaultByPriority(activeNavCompany.id, null, null, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp }),
                fetchWorstPerformingEquipment(activeNavCompany.id, null, null, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, isSystem: activeEquipmentSystemType?.grouping === 'System Type' }),
                fetchSiteScoreData(activeNavCompany.id, null, null, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp }),
                /*  fetchEquipmentEnergyData(null, null, null, { startDate:        dashboardStartTimeStamp, endDate:          dashboardEndTimeStamp , EnergyTabView:    'Equipment',
                    EnergyUnit:       'Watts',
                    Interval:         15,
                    TimeIntervalUnit: 'minutes'})
                    */
            ].map(p => p.catch(err => err)));
        };

        if (activeNavCompany.id && isEmpty(activeClient) && isEmpty(activeSite)) init();
    }, [activeNavCompany.id, dashboardEndTimeStamp, dashboardStartTimeStamp]);

    useEffect(() => {
        const initClient = async () => {
            if (!isEmpty(activeEquipmentSystemType)) {
                if (activeEquipmentSystemType.grouping === 'Equipment Type') {
                    await Promise.all([
                        fetchFaultByRule(activeNavCompany.id, activeClient.id, null, { StartDate: dashboardStartTimeStamp, EndDate: dashboardEndTimeStamp, equipmentTypeId: activeEquipmentSystemType.id }),
                        fetchFaultByPriority(activeNavCompany.id, activeClient.id, null, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, equipmentTypeId: activeEquipmentSystemType.id }),
                        fetchSiteScoreData(activeNavCompany.id, activeClient.id, null, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, equipmentTypeId: activeEquipmentSystemType.id }),
                        fetchWorstPerformingEquipment(activeNavCompany.id, activeClient.id, null, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, equipmentTypeId: activeEquipmentSystemType.id, isSystem: false })
                    ].map(p => p.catch(err => err)));
                } else {
                    await Promise.all([
                        fetchFaultByRule(activeNavCompany.id, activeClient.id, null, { StartDate: dashboardStartTimeStamp, EndDate: dashboardEndTimeStamp, systemTypeId: activeEquipmentSystemType.id }),
                        fetchFaultByPriority(activeNavCompany.id, activeClient.id, null, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, systemTypeId: activeEquipmentSystemType.id }),
                        fetchSiteScoreData(activeNavCompany.id, activeClient.id, null, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, systemTypeId: activeEquipmentSystemType.id }),
                        fetchWorstPerformingEquipment(activeNavCompany.id, activeClient.id, null, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, systemTypeId: activeEquipmentSystemType.id, isSystem: true })
                    ].map(p => p.catch(err => err)));
                }
            } else {
                await Promise.all([
                    fetchFaultByRule(activeNavCompany.id, activeClient.id, null, { StartDate: dashboardStartTimeStamp, EndDate: dashboardEndTimeStamp }),
                    fetchFaultByPriority(activeNavCompany.id, activeClient.id, null, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp }),
                    fetchWorstPerformingEquipment(activeNavCompany.id, activeClient.id, null, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp }),
                    fetchSiteScoreData(activeNavCompany.id, activeClient.id, null, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp }),
                    /*   fetchEquipmentEnergyData(activeClient.id, null, null, { startDate:        dashboardStartTimeStamp, endDate:          dashboardEndTimeStamp , EnergyTabView:    'Client',
                        EnergyUnit:       'Watts',
                        Interval:         15,
                        TimeIntervalUnit: 'minutes'})
                        */
                ].map(p => p.catch(err => err)));
            }
        };

        const initRemoveClient = async () => {
            setActiveClient({});
            setActiveSite({});

            if (!isEmpty(activeEquipmentSystemType)) {
                if (activeEquipmentSystemType.grouping === 'Equipment Type') {
                    await Promise.all([
                        fetchFaultByRule(activeNavCompany.id, null, null, { StartDate: dashboardStartTimeStamp, EndDate: dashboardEndTimeStamp, equipmentTypeId: activeEquipmentSystemType.id }),
                        fetchFaultByPriority(activeNavCompany.id, null, null, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, equipmentTypeId: activeEquipmentSystemType.id }),
                        fetchSiteScoreData(activeNavCompany.id, null, null, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, equipmentTypeId: activeEquipmentSystemType.id }),
                        fetchWorstPerformingEquipment(activeNavCompany.id, null, null, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, equipmentTypeId: activeEquipmentSystemType.id, isSystem: false })
                    ].map(p => p.catch(err => err)));
                } else {
                    await Promise.all([
                        fetchFaultByRule(activeNavCompany.id, null, null, { StartDate: dashboardStartTimeStamp, EndDate: dashboardEndTimeStamp, systemTypeId: activeEquipmentSystemType.id }),
                        fetchFaultByPriority(activeNavCompany.id, null, null, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, systemTypeId: activeEquipmentSystemType.id }),
                        fetchSiteScoreData(activeNavCompany.id, null, null, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, systemTypeId: activeEquipmentSystemType.id }),
                        fetchWorstPerformingEquipment(activeNavCompany.id, null, null, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, systemTypeId: activeEquipmentSystemType.id, isSystem: true })
                    ].map(p => p.catch(err => err)));
                }
            } else {
                await Promise.all([
                    fetchFaultByRule(activeNavCompany.id, null, null, { StartDate: dashboardStartTimeStamp, EndDate: dashboardEndTimeStamp }),
                    fetchFaultByPriority(activeNavCompany.id, null, null, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp }),
                    fetchWorstPerformingEquipment(activeNavCompany.id, null, null, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp }),
                    fetchSiteScoreData(activeNavCompany.id, null, null, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp })
                ].map(p => p.catch(err => err)));
            }
        };

        if (activeClient && activeClient.id && isEmpty(activeSite) && isEmpty(zoomSite)) {
            initClient();
        } else if (activeNavCompany.id && !activeClient) {
            initRemoveClient();
        }
    }, [activeClient, dashboardEndTimeStamp, dashboardStartTimeStamp]);
    new Date(moment(dashboardEndTimeStamp).add(1, 'days'));
    useEffect(() => {
        const initSite = async () => {
            if (!isEmpty(activeEquipmentSystemType)) {
                if (activeEquipmentSystemType.grouping === 'Equipment Type') {
                    await Promise.all([
                        fetchFaultByRule(activeNavCompany.id, activeClient.id, activeSite.id, { StartDate: dashboardStartTimeStamp, EndDate: dashboardEndTimeStamp, equipmentTypeId: activeEquipmentSystemType.id }),
                        fetchFaultByPriority(activeNavCompany.id, activeClient.id, activeSite.id, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, equipmentTypeId: activeEquipmentSystemType.id }),
                        fetchSiteScoreData(activeNavCompany.id, activeClient.id, activeSite.id, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, equipmentTypeId: activeEquipmentSystemType.id }),
                        fetchWorstPerformingEquipment(activeNavCompany.id, activeClient.id, activeSite.id, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, equipmentTypeId: activeEquipmentSystemType.id, isSystem: false }),
                        // fetchEnergyEquipmentSummary(activeNavCompany.id,activeClient.id, activeSite.id, {
                        //     StartDate:        dashboardStartTimeStamp,
                        //     EndDate:          dashboardEndTimeStamp,
                        //     EnergyTabView:    'Equipment',
                        //     EnergyUnit:       'Watts',
                        //     energyHog:        true,
                        //     Interval:         15,
                        //     TimeIntervalUnit: 'minutes'
                        // }),
                        // fetchEnergyEquipmentGroupSummary(activeSite.id, {
                        //     StartDate: dashboardStartTimeStamp,
                        //     EndDate:   dashboardEndTimeStamp
                        // })
                    ].map(p => p.catch(err => err)));
                } else {
                    await Promise.all([
                        fetchFaultByRule(activeNavCompany.id, activeClient.id, activeSite.id, { StartDate: dashboardStartTimeStamp, EndDate: dashboardEndTimeStamp, systemTypeId: activeEquipmentSystemType.id }),
                        fetchFaultByPriority(activeNavCompany.id, activeClient.id, activeSite.id, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, systemTypeId: activeEquipmentSystemType.id }),
                        fetchSiteScoreData(activeNavCompany.id, activeClient.id, activeSite.id, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, systemTypeId: activeEquipmentSystemType.id }),
                        fetchWorstPerformingEquipment(activeNavCompany.id, activeClient.id, activeSite.id, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, systemTypeId: activeEquipmentSystemType.id, isSystem: true }),
                        // fetchEnergyEquipmentSummary(activeNavCompany.id,activeClient.id, activeSite.id, {
                        //     StartDate:        dashboardStartTimeStamp,
                        //     EndDate:          dashboardEndTimeStamp,
                        //     EnergyTabView:    'Equipment',
                        //     energyHog:        true,
                        //     EnergyUnit:       'Watts',
                        //     Interval:         15,
                        //     TimeIntervalUnit: 'minutes'
                        // }),
                        // fetchEnergyEquipmentGroupSummary(activeSite.id, {
                        //     StartDate: dashboardStartTimeStamp,
                        //     EndDate:   dashboardEndTimeStamp
                        // })
                    ].map(p => p.catch(err => err)));
                }
            } else {
                await Promise.all([
                    fetchFaultByRule(activeNavCompany.id, activeClient.id, activeSite.id, { StartDate: dashboardStartTimeStamp, EndDate: dashboardEndTimeStamp }),
                    fetchFaultByPriority(activeNavCompany.id, activeClient.id, activeSite.id, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp }),
                    fetchSiteScoreData(activeNavCompany.id, activeClient.id, activeSite.id, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp }),
                    fetchWorstPerformingEquipment(activeNavCompany.id, activeClient.id, activeSite.id, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp }),
                    // fetchEnergyEquipmentSummary(activeNavCompany.id,activeClient.id, activeSite.id, {
                    //     StartDate:        dashboardStartTimeStamp,
                    //     EndDate:          dashboardEndTimeStamp,
                    //     EnergyTabView:    'Equipment',
                    //     EnergyUnit:       'Watts',
                    //     energyHog:        true,
                    //     Interval:         15,
                    //     TimeIntervalUnit: 'minutes'
                    // }),
                    // fetchEnergyEquipmentGroupSummary(activeSite.id, {
                    //     StartDate: dashboardStartTimeStamp,
                    //     EndDate:   dashboardEndTimeStamp
                    // })
                ].map(p => p.catch(err => err)));
            }
        };

        const initRemoveSite = async () => {
            setActiveSite({});

            if (!isEmpty(activeEquipmentSystemType)) {
                if (activeEquipmentSystemType.grouping === 'Equipment Type') {
                    await Promise.all([
                        fetchFaultByRule(activeNavCompany.id, activeClient.id, null, { StartDate: dashboardStartTimeStamp, EndDate: dashboardEndTimeStamp, equipmentTypeId: activeEquipmentSystemType.id }),
                        fetchFaultByPriority(activeNavCompany.id, activeClient.id, null, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, equipmentTypeId: activeEquipmentSystemType.id }),
                        fetchSiteScoreData(activeNavCompany.id, activeClient.id, null, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, equipmentTypeId: activeEquipmentSystemType.id }),
                        fetchWorstPerformingEquipment(activeNavCompany.id, activeClient.id, null, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, equipmentTypeId: activeEquipmentSystemType.id, isSystem: false })
                    ].map(p => p.catch(err => err)));
                } else {
                    await Promise.all([
                        fetchFaultByRule(activeNavCompany.id, activeClient.id, null, { StartDate: dashboardStartTimeStamp, EndDate: dashboardEndTimeStamp, systemTypeId: activeEquipmentSystemType.id }),
                        fetchFaultByPriority(activeNavCompany.id, activeClient.id, null, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, systemTypeId: activeEquipmentSystemType.id }),
                        fetchSiteScoreData(activeNavCompany.id, activeClient.id, null, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, systemTypeId: activeEquipmentSystemType.id }),
                        fetchWorstPerformingEquipment(activeNavCompany.id, activeClient.id, null, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, systemTypeId: activeEquipmentSystemType.id, isSystem: true })
                    ].map(p => p.catch(err => err)));
                }
            } else {
                await Promise.all([
                    fetchFaultByRule(activeNavCompany.id, activeClient.id, null, { StartDate: dashboardStartTimeStamp, EndDate: dashboardEndTimeStamp }),
                    fetchFaultByPriority(activeNavCompany.id, activeClient.id, null, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp }),
                    fetchWorstPerformingEquipment(activeNavCompany.id, activeClient.id, null, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp }),
                    fetchSiteScoreData(activeNavCompany.id, activeClient.id, null, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp })
                ].map(p => p.catch(err => err)));
            }
        };

        if (activeSite && activeSite.id) {
            initSite();
        } else if (activeNavCompany.id && !activeSite) {
            initRemoveSite();
        }
    }, [activeSite, dashboardEndTimeStamp, dashboardStartTimeStamp]);

    useEffect(() => {
        const init = async () => {
            if (activeEquipmentSystemType.grouping === 'Equipment Type') {
                await Promise.all([
                    fetchFaultByRule(activeNavCompany.id, activeClient.id, activeSite.id, { StartDate: dashboardStartTimeStamp, EndDate: dashboardEndTimeStamp, equipmentTypeId: activeEquipmentSystemType.id }),
                    fetchFaultByPriority(activeNavCompany.id, activeClient.id, activeSite.id, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, equipmentTypeId: activeEquipmentSystemType.id }),
                    fetchSiteScoreData(activeNavCompany.id, activeClient.id, activeSite.id, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, equipmentTypeId: activeEquipmentSystemType.id }),
                    fetchWorstPerformingEquipment(activeNavCompany.id, activeClient.id, activeSite.id, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, equipmentTypeId: activeEquipmentSystemType.id, isSystem: false }),
                    /* fetchEquipmentEnergyData(activeClient.id, activeSite.id,  '9e77015e-5d72-4e26-8ebc-ef6b3a689d6b', { startDate:        dashboardStartTimeStamp, endDate:          dashboardEndTimeStamp , EnergyTabView:    'Equipment',
                        EnergyUnit:       'Watts',
                        Interval:         15,
                        TimeIntervalUnit: 'minutes'})
                        */
                    /* fetchSiteEnergyData(activeClient.id, activeSite.id, {
                        StartDate:        dashboardStartTimeStamp,
                        EndDate:          dashboardEndTimeStamp,
                        EnergyTabView:    'Site',
                        EnergyUnit:       'Watts',
                        Interval:         15,
                        TimeIntervalUnit: 'minutes'
                    })
                    */
                ].map(p => p.catch(err => err)));
            } else {
                await Promise.all([
                    fetchFaultByRule(activeNavCompany.id, activeClient.id, activeSite.id, { StartDate: dashboardStartTimeStamp, EndDate: dashboardEndTimeStamp, systemTypeId: activeEquipmentSystemType.id }),
                    fetchFaultByPriority(activeNavCompany.id, activeClient.id, activeSite.id, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, systemTypeId: activeEquipmentSystemType.id }),
                    fetchSiteScoreData(activeNavCompany.id, activeClient.id, activeSite.id, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, systemTypeId: activeEquipmentSystemType.id }),
                    fetchWorstPerformingEquipment(activeNavCompany.id, activeClient.id, activeSite.id, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, systemTypeId: activeEquipmentSystemType.id, isSystem: true }),
                    /* fetchSiteEnergyData(activeClient.id, activeSite.id, {
                        StartDate:        dashboardStartTimeStamp,
                        EndDate:          dashboardEndTimeStamp,
                        EnergyTabView:    'Site',
                        EnergyUnit:       'Watts',
                        Interval:         15,
                        TimeIntervalUnit: 'minutes'
                    })
                    */
                    /* fetchEquipmentEnergyData(activeClient.id, activeSite.id,  '9e77015e-5d72-4e26-8ebc-ef6b3a689d6b', { startDate:        dashboardStartTimeStamp, endDate:          dashboardEndTimeStamp , EnergyTabView:    'Equipment',
                        EnergyUnit:       'Watts',
                        Interval:         15,
                        TimeIntervalUnit: 'minutes'})
                        */
                ].map(p => p.catch(err => err)));
            }
        };

        const initRemoveType = async () => {
            await Promise.all([
                fetchFaultByRule(activeNavCompany.id, activeClient.id, activeSite.id, { StartDate: dashboardStartTimeStamp, EndDate: dashboardEndTimeStamp }),
                fetchFaultByPriority(activeNavCompany.id, activeClient.id, activeSite.id, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp }),
                fetchSiteScoreData(activeNavCompany.id, activeClient.id, activeSite.id, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp }),
                fetchWorstPerformingEquipment(activeNavCompany.id, activeClient.id, activeSite.id, { startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp })
            ].map(p => p.catch(err => err)));
        };

        if (!isEmpty(activeEquipmentSystemType)) {
            init();
        } else if (isEmpty(activeEquipmentSystemType) && !isEmpty(activeNavCompany)) {
            initRemoveType();
        }
    }, [activeEquipmentSystemType, dashboardEndTimeStamp, dashboardStartTimeStamp]);

    const handleReposition = (e) => {
        localStorage.setItem(`ExecutiveSummaryConfig-${userId}`, JSON.stringify(e.value));
        setData(e.value);
    };

    const renderSelectedComponent = () => {
        switch (selectedTitle) {
            case 'Average Score':
                return <ExecutiveSummaryScoreGuage />;
            case 'Site Score':
                return (
                    <ExecutiveSummarySitesTable
                        setZoomSite={setZoomSite}
                        setActiveClient={setActiveClient}
                        setActiveSite={setActiveSite}
                        setSites={setSummarySites}
                        expanded={true}
                    />);
            case '10 Worst Performing Equipment':
            case '10 Worst Performing Systems':
                return <ExecutiveSummaryEquipmentsTable extendedColumns={true} />;
            case 'Faults By Site':
                return <ExecutiveSummaryFaults zoomSite={zoomSite} />;
            case 'BAS Agent Connectivity':
                return <ExecutiveSummaryAgentsTable expanded={true} />;
            case 'Faults By Priority':
                return <ExecutiveSummaryFaultsByPriority faultFilters={faultFilters} setFaultFilters={setFaultFilters} extendedColumns={true} />;
            case 'Faults By Rule':
                return <ExecutiveSummaryFaultsByRule extendedColumns={true} />;
            case 'Top 10 Energy Hogs (Previous Month)':
                return <ExecutiveSummaryEnergyHogs extendedColumns={true} />;
            case 'Energy Use by Equipment Type':
                return <ExecutiveSummarEnergyUse extendedColumns={true} />;
            default:
                return null;
        }
    };

    const handleCompanyChange = async (event, value) => {
        if (!value) return;
        setActiveClient({});
        setActiveSite({});
        await Promise.all([
            setActiveNavCompany(value),
            setNavCompany(value),
            fetchNavClients(value.id)
        ].map(p => p.catch(err => err))).then(async () => {
            const currentCompany = companies.find(c => c.company.id === value.id);
            if (currentCompany) {
                sessionStorage.setItem('companyId', value.id);
                await fetchCompanyInfo(currentCompany);
                dispatch(enqueueSnackbar('Company changed sucessfully', 'success'));
            }
            history.push(`/v2/dashboard/executivesummary?company=${value.id}`);
        });
    };

    return (
        <BobPage>
            <div className={companies.length > 1 ? classes.ExecutiveSummaryAlt : classes.ExecutiveSummary}>
                {
                    companies.length > 1 ?
                        <AutoComplete
                            className={classes.CompanySelector}
                            id="clientId"
                            name="clientId"
                            options={sortBy(companyList, 'name')}
                            getOptionLabel={(option) => option.name || 'All'}
                            getOptionSelected={(option, value) => option && value ? option.name === value.name : ''}
                            value={activeCompany}
                            onChange={(event, value) => handleCompanyChange(event, value)}
                            size="small"
                            required
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    label={'Company'}
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <React.Fragment>
                                                {!companies.length ? <CircularProgress color="inherit" size={15} /> : null}
                                                {params.InputProps.endAdornment}
                                            </React.Fragment>
                                        ),
                                    }}
                                />}
                        />
                        :
                        <React.Fragment>
                            <div className={classes.Title}>
                                Company
                            </div>
                            <div className={classes.Label}>
                                {activeNavCompany.name}
                            </div>
                        </React.Fragment>
                }
                <div className={classes.Selectors}>
                    <EntitySelector
                        activeClient={activeClient}
                        setActiveClient={setActiveClient}
                        activeSite={activeSite}
                        setActiveSite={setActiveSite}
                        activeEquipmentSystemType={activeEquipmentSystemType}
                        setActiveEquipmentSystemType={setActiveEquipmentSystemType}
                        sites={summarySites}
                        setSites={setSummarySites}
                        clients={summaryClients}
                        setClients={setSummaryClients}
                        equipmentSystemTypes={summaryEquipmentSystemTypes}
                        setEquipmentSystemTypes={setSummaryEquipmentSystemTypes}
                        setZoomSite={setZoomSite}
                    />
                    <div className={classes.TimestampFilter}>
                        <BobTimeStampFilter
                            className={classes.TimestampOverride}
                            maxDate={moment().local()}
                            disableIntervalSelector={true}
                        />
                    </div>
                    <div className={classes.SettingsIcon}>
                        <TileSelector
                            availableTiles={availableTiles}
                            selectedTiles={selectedTiles}
                            setSelectedTiles={setSelectedTiles}
                            setLoading={setLoading}
                        />
                    </div>
                </div>
                <div className={classes.SummaryBody}>
                    {
                        isEmpty(data) ?
                            null
                            :
                            <TileLayout
                                columns={3}
                                rowHeight={430}
                                positions={data}
                                gap={{
                                    rows:    20,
                                    columns: 20,
                                }}
                                ignoreDrag={(e) => { return !(e.target.parentElement.className.includes('TileContainer_TileHeader')); }}
                                items={tiles || []}
                                onReposition={handleReposition}
                            />
                    }
                </div>
            </div>
            {
                tileModalOpen ?
                    <ExecutiveSummaryTileModal
                        setTileModalOpen={setTileModalOpen}
                        setSelectedTitle={setSelectedTitle}
                        title={selectedTitle}
                    >
                        {renderSelectedComponent()}
                    </ExecutiveSummaryTileModal>
                    :
                    null
            }
            {
                loading || !hasInitialized ?
                    <BobLoadingMask />
                    :
                    null
            }
        </BobPage>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany:        state.bob.activeNavCompany,
        attributes:              state.attributeManagement.attributes,
        companies:               state.core.companies,
        configurations:          state.configurationData.allConfigurations,
        currentUser:             state.currentUser,
        dashboardEndTimeStamp:   state.dashboard.dashboardEndTimeStamp ? state.dashboard.dashboardEndTimeStamp.format() : null,
        dashboardStartTimeStamp: state.dashboard.dashboardStartTimeStamp ? state.dashboard.dashboardStartTimeStamp.format() : null,
        sites:                   state.executiveSummary.sites,
        userId:                  state.currentUser.id
    };
};

const mapDispatchToProps = {
    ...bobActions,
    ...basAgentActions,
    ...companyInfoActions,
    ...configurationActions,
    ...executiveSummaryActions,
    ...CompanyManagementActions,
    ...EnergyActions,
    ...lookupActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ExecutiveSummary));
